let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1bNGv")).then(() => parcelRequire('aD8pc'));